import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { SearchHistoryService } from 'src/app/services/search-history.service';

@Component({
  selector: 'app-session-log',
  templateUrl: './radact.component.html',
  styleUrls: ['./radact.component.scss']
})
export class RadactComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "Username",
    "IP",
    "Caller",
    "NAS",
    "Start",
    "Stop",
    "Download",
    "Upload"
  ];
  searchform: FormGroup;
  searchQuery: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageNumber: 1;
  pageSize: 50;
  totalRecords: 0;
  totalCount: any;

  constructor(
    private searchHistoryService: SearchHistoryService,
    private toast: ToastrService,
    private applicationDataService: ApplicationDataService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    console.log('Initial PageNumber:', this.pageNumber);
    console.log('Initial PageSize:', this.pageSize);
    this.gettabledata();

    this.searchform = this.formBuilder.group({
      SearchQuery: [null],
    })
  }

  buildPaginationRequest() {
    return {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };
  }
  gettabledata() {

    this.searchHistoryService.getSessionLogData().subscribe((result) => {
      this.data = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;

    })
  }

  refresh() {
    this.searchform.reset();

    this.pageNumber = 1;
    this.pageSize = 50;
    this.totalCount = 0;

    this.gettabledata();
  }

  search() {
    const searchValue = this.searchform.get('SearchQuery')?.value;
    console.log(searchValue)
    if (searchValue) {
      const payload = {
        portalUserName: searchValue,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      this.searchHistoryService.getSessionLogForSingleUser(payload).subscribe(
        (result) => {
          if (result) {
            this.totalCount = result.totalCount;
            this.pageNumber = result.pageNumber;
            this.pageSize = result.pageSize;

            this.data = result.details;
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.paginator = this.paginator;
          }
        });
    }
    else {
      this.toast.error("Please enter search query")
    }
  }

  onPageChange(event: any) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.search();
  }
  exportData() {
    const searchValue = this.searchform.get('SearchQuery')?.value || '';

    this.applicationDataService.exportSessionLogData(searchValue).subscribe(
      (data) => {
        if (data) {
          const linkSource = 'data:application/vnd.ms-excel;base64, ' + data;
          const downloadLink = document.createElement('a');
          const fileName = "SessionLogData_" + moment().format("DDMMYYYYHHmmss") + '.xlsx';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
        else {
          this.toast.error("Oops something went wrong");
        }

      }
    );
  }
  preventLeadingSpace(event: Event) {
    const e = event as KeyboardEvent;
    const input = e.target as HTMLInputElement;

    if (e.key === ' ' && input.selectionStart === 0) {
      e.preventDefault();
    }
  }

  formatBytes(bytes: number): string {
    if (!bytes || bytes === 0) return '0 MB';

    const GB = 1024 * 1024 * 1024;
    const MB = 1024 * 1024;

    if (bytes >= GB) {
      return (bytes / GB).toFixed(2) + ' GB';
    } else {
      return (bytes / MB).toFixed(2) + ' MB';
    }
  }
}
